import type { RouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type CancelEventRequestBody = paths['/events/{id}/cancel']['post']['parameters']['path'];
type CancelEventResponse = paths['/events/{id}/cancel']['post']['responses']['201']['content']['application/json'];

export const cancelEvent = async ({ routeParams: { id } }: RouteParamsRequest<CancelEventRequestBody>) =>
  nodeApiClient.post<CancelEventResponse, ApiClientResponse<CancelEventResponse>>(nodeApiRoutes.events.cancel(id));
